module.exports = __webpack_public_path__ + "static/media/marionBetty00.02c4f448.png";